import { QuestionSearchSortBy } from 'src/modules/exam-preparation/graphql/question/types';
import QPAPIs from '../question-paper';
// Helper function to check if a question is a duplicate
export const isDuplicateQuestion = (question) => {
    const isOriginal = question.attributes?.isOriginal;
    if (typeof isOriginal === 'boolean')
        return !isOriginal;
    // Below is a fallback logic in case the Application
    // hasn't downloaded attributes.isOriginal changes yet.
    const duplicateRef = question.data.duplicateRef;
    // If duplicateRef exists and is different from _id, it's a duplicate
    return !!(duplicateRef && duplicateRef !== question._id);
};
// Helper function to get question paper data for sorting
export const getQuestionPaperData = async (userID, question) => {
    try {
        const questionPaper = await QPAPIs.getForQuestion(userID, question._id);
        return questionPaper;
    }
    catch (error) {
        // If question paper cannot be resolved, use a fallback date
        console.warn(`Could not resolve question paper for question ${question._id}:`, error);
        return { data: { dateNL: '1900-01-01T00:00:00.000Z' } };
    }
};
// Helper function to apply sorting to questions
export const applySorting = async (userID, questions, sortBy = QuestionSearchSortBy.TOPICS) => {
    switch (sortBy) {
        case QuestionSearchSortBy.QP_DATE: {
            // Sort by question paper date (newest first)
            const questionsWithQP = await Promise.all(questions.map(async (question) => ({
                question,
                questionPaper: await getQuestionPaperData(userID, question),
            })));
            const sortedQuestionsWithQP = questionsWithQP.sort((a, b) => {
                const dateA = new Date(a.questionPaper.data.date);
                const dateB = new Date(b.questionPaper.data.date);
                // First sort by question paper date (descending order - newest first)
                const dateComparison = dateB.getTime() - dateA.getTime();
                if (dateComparison !== 0)
                    return dateComparison;
                // If dates match, sort by sequence in ascending order
                const sequenceA = a.question.data.sequence || 0;
                const sequenceB = b.question.data.sequence || 0;
                return sequenceA - sequenceB;
            });
            return sortedQuestionsWithQP.map(item => item.question);
        }
        case QuestionSearchSortBy.TOPICS: {
            // Sort by first topic alphabetically
            const sortedQuestionsWithQP = questions.sort((a, b) => {
                const topicsA = a.data.topics || [];
                const topicsB = b.data.topics || [];
                const firstTopicA = topicsA[0] || '';
                const firstTopicB = topicsB[0] || '';
                // Sort by topic alphabetically
                return firstTopicA.localeCompare(firstTopicB);
            });
            return sortedQuestionsWithQP;
        }
        case QuestionSearchSortBy.DUPLICATES_COUNT: {
            const sortedQuestionsWithDuplicatesCount = questions.sort((a, b) => {
                const duplicatesCountA = a.attributes?.duplicatesCount || 0;
                const duplicatesCountB = b.attributes?.duplicatesCount || 0;
                // Sort by duplicates count (descending)
                return duplicatesCountB - duplicatesCountA;
            });
            return sortedQuestionsWithDuplicatesCount;
        }
        default:
            // Default to QP_DATE sorting
            return applySorting(userID, questions, QuestionSearchSortBy.QP_DATE);
    }
};
